import { getFromDataPath, mutateByPath, removeByPath } from "../../../utility";
import { ArsTableCellType, ArsTableState, ArstActionContextmenuAction } from "../interface";
import { isArsTableSubGroup } from "../typeguards/isArsTableSubGroup";
import { arst_resolveTargetPath } from "./arst_resolveTargetPath";

/**
 * Toggles the inline row header setting for a row group.
 *
 * @param state - Current ARS table state
 * @param action - Context-menu action describing the group label cell to toggle
 * @returns Updated ARS table state
 */
export const arst_toggleInlineRowHeader = <T>(
  state: ArsTableState<T>,
  action: ArstActionContextmenuAction<T>,
): ArsTableState<T> => {
  if (
    action.cellValue.cellType !== ArsTableCellType.RowGroupCell &&
    action.cellValue.cellType !== ArsTableCellType.RowGroupLabel
  ) {
    return state;
  }

  const targetGroupingFactorPath = arst_resolveTargetPath(action.cellValue.dataPath);
  const targetItem = getFromDataPath(targetGroupingFactorPath, state.bodyData, (obj) =>
    isArsTableSubGroup(obj, state.settings.editorProps.isT),
  );
  if (!targetItem) return state;

  let newBodyData = { ...state.bodyData };
  /* istanbul ignore else */
  if (targetItem?.inlineRowHeaders) {
    // Remove if it is already there
    newBodyData = removeByPath(newBodyData, `${targetGroupingFactorPath}/inlineRowHeaders`);
    // Add rowHeader cell back in
    newBodyData.rowHeaders = [...state.bodyData.rowHeaders];
    newBodyData.rowHeaders.splice(action.cellValue.columnIndex, 0, {
      heights: [],
      label: state.settings.editorProps.blankT,
      width: 120,
    });
  } else if (targetItem) {
    // Add if it is not there or false
    newBodyData = mutateByPath(
      state.bodyData,
      `${targetGroupingFactorPath}/inlineRowHeaders`,
      true,
    );
    // Remove rowHeader cell, there should be less now
    newBodyData.rowHeaders = [...state.bodyData.rowHeaders];
    newBodyData.rowHeaders.splice(
      action.cellValue.columnIndex -
        (action.cellValue.cellType === ArsTableCellType.RowGroupLabel ? 1 : 0),
      1,
    );
  }

  return {
    ...state,
    bodyData: newBodyData,
    changed: true,
  };
};
